export enum ClaimsType {
  CED = "CED",
  SFPJ = "SFPJ",
  RMA= "RMA",
  ALTIMA = "ALTIMA",
}
